import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  icons:{
    iconfont: 'mdi'
  },
  render: h => h(App)
}).$mount('#app')
